import { createFileRoute } from '@tanstack/react-router';
import AuthGuard from '@/components/auth-guard';
import { NotificationSettings } from '@/components/notifications/notification-settings';
import { HouseholdSettings } from '@/components/settings/household-settings';
import { WhatsAppSettings } from '@/components/settings/whatsapp-settings';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export const Route = createFileRoute('/settings')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AuthGuard requireAuth={true}>
      <div className="container mx-auto max-w-4xl p-6">
        <div className="space-y-6">
          <div>
            <h1 className="font-bold text-3xl tracking-tight">Configurações</h1>
            <p className="text-muted-foreground">
              Gerencie as configurações da sua conta e preferências.
            </p>
          </div>

          <Tabs className="space-y-4" defaultValue="whatsapp">
            <TabsList>
              <TabsTrigger value="whatsapp">WhatsApp</TabsTrigger>
              <TabsTrigger value="account">Conta</TabsTrigger>
              <TabsTrigger value="notifications">Notificações</TabsTrigger>
              <TabsTrigger value="household">Casa</TabsTrigger>
            </TabsList>

            <TabsContent className="space-y-4" value="whatsapp">
              <WhatsAppSettings />
            </TabsContent>

            <TabsContent className="space-y-4" value="account">
              <div className="py-12 text-center">
                <h3 className="mb-2 font-semibold text-lg">
                  Configurações da Conta
                </h3>
                <p className="text-muted-foreground">
                  Gerenciamento de conta em breve!
                </p>
              </div>
            </TabsContent>

            <TabsContent className="space-y-4" value="notifications">
              <NotificationSettings />
            </TabsContent>

            <TabsContent className="space-y-4" value="household">
              <HouseholdSettings />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </AuthGuard>
  );
}
